import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'prox-save-cancel',
  template: `
    <div class="qb-page-footer flex items-center">
      <div *ngIf="!isReadOnly" class="mr-2">
        <button
          (click)="onSave()"
          [disabled]="!uow.hasChanges()"
          pButton
          type="button"
          label="Save"
          icon="pi pi-check"
          class="p-button-raised"
          id="prox-save-btn"
        ></button>
      </div>

      <div class="pr-2" *ngIf="!isHideUndo() && !isReadOnly">
        <button
          (click)="onUndo()"
          [disabled]="!uow.hasChanges()"
          pButton
          type="button"
          icon="pi pi-undo"
          label="Undo"
          class="p-button-raised"
          id="prox-undo-btn"
        ></button>
      </div>

      <div class="pr-2" *ngIf="hasCancel">
        <button
          (click)="onCancel()"
          pButton
          type="button"
          icon="{{ setCancelIcon() }}"
          label="{{ setCancelLabel() }}"
          class="p-button-raised"
          id="prox-cancel-btn"
        ></button>
      </div>

      <!-- Slot for additional buttons (e.g., View Notes) -->
      <ng-content></ng-content>

      <div class="grow"></div>

      <div *ngIf="uow.canShowLog()">
        <p-button icon="pi pi-eye" styleClass="p-button-rounded p-button-text" title="Change Log" (onClick)="onShowLog()"></p-button>
      </div>
      <div *ngIf="hasConfirmDialog">
      </div>
    </div>
  `,
  standalone: false,
})
export class ProxSaveCancelComponent implements OnInit {
  @Input() uow!: {
    hasChanges: () => boolean;
    canShowLog: () => boolean;
    showChangeLog: () => Promise<boolean>;
  };
  @Input() hideUndo: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() hasConfirmDialog: boolean = true;
  @Output() cancel = new EventEmitter<string>();
  @Output() save = new EventEmitter<string>();
  @Output() undo = new EventEmitter<string>();
  // @Output() showLog = new EventEmitter<string>();
  hasCancel = false;

  ngOnInit(): void {
    this.hasCancel = this.cancel.observed;
  }

  onCancel() {
    this.cancel.emit('cancel');
  }
  onSave() {
    this.save.emit('save');
  }
  onUndo() {
    this.undo.emit('undo');
  }
  onShowLog() {
    this.uow.showChangeLog();
  }

  isHideUndo() {
    return this.hideUndo;
  }

  setCancelIcon() {
    if (!this.uow.hasChanges()) {
      return 'pi pi-backward';
    }
    return 'pi pi-times';
  }

  setCancelLabel(): string {
    if (!this.uow.hasChanges()) {
      return ' Go Back';
    }
    return ' Cancel and Go Back';
  }
}
